export function loadCartList(needsPreCreate = false, cartType = 1) {
  return {
    type: 'LOAD_CART_LIST',
    needsPreCreate,
    cartType,
  };
}
export function loadCartListCompletion(cartType = 1, error = null, list = []) {
  return {
    type: 'LOAD_CART_LIST_COMPLETION',
    cartType,
    error,
    list,
  };
}
export function setStorageCartSelection(cartType = 1, storageSelection = {}) {
  return {
    type: 'SET_STORAGE_CART_SELECTION',
    cartType,
    storageSelection,
  };
}
export function updateCartSelection(updateList = [], cartType = 1) {
  return {
    type: 'UPDATE_CART_SELECTION',
    updateList,
    cartType,
  };
}
export function updateCartUnselection(updateList = [], cartType = 1) {
  return {
    type: 'UPDATE_CART_UNSELECTION',
    updateList,
    cartType,
  };
}
export function editCartItem(code, cartType = 1) {
  return {
    type: 'EDIT_CART_ITEM',
    code,
    cartType,
  };
}
export function updateCartNumber(code, number, cartType = 1) {
  return {
    type: 'UPDATE_CART_NUMBER',
    code,
    number,
    cartType,
  };
}
export function loadCartNumber(cartType = 1) {
  return {
    type: 'LOAD_CART_NUMBER',
    cartType,
  };
}
export function loadCartNumberCompletion(
  cartType = 1,
  error = null,
  data = {}
) {
  return {
    type: 'LOAD_CART_NUMBER_COMPLETION',
    cartType,
    error,
    data,
  };
}
export function addCart(addList = [], cartType = 1) {
  return {
    type: 'ADD_CART',
    addList,
    cartType,
  };
}
export function addCartCompletion(
  cartType = 1,
  error = null,
  data = {},
  addList = []
) {
  return {
    type: 'ADD_CART_COMPLETION',
    cartType,
    error,
    data,
    addList,
  };
}

export function addCartDefaultGift(addList = [], cartType = 1) {
  return {
    type: 'ADD_CART_DEFAULT_GIFT',
    addList,
    cartType,
  };
}
export function addCartDefaultGiftCompletion(
  cartType = 1,
  error = null,
  data = {},
  addList = []
) {
  return {
    type: 'ADD_CART_DEFAULT_GIFT_COMPLETION',
    cartType,
    error,
    data,
    addList,
  };
}

export function addXgCart(addList = []) {
  return {
    type: 'ADD_XG_CART',
    addList,
  };
}

export function addXgCartCompletion(productId, error, data) {
  return {
    type: 'ADD_XG_CART_COMPLETION',
    productId,
    error,
    data,
  };
}

export function removeCart(
  removeList = [],
  cartType = 1,
  needRefreshCart = true
) {
  return {
    type: 'REMOVE_CART',
    removeList,
    cartType,
    needRefreshCart,
  };
}
export function removeCartCompletion(
  cartType = 1,
  error = null,
  data = {},
  removeList = []
) {
  return {
    type: 'REMOVE_CART_COMPLETION',
    cartType,
    error,
    data,
    removeList,
  };
}
export function updateCartItem(code, number = 0, oldNumber = 0, cartType = 1) {
  return {
    type: 'UPDATE_CART_ITEM',
    code,
    number,
    oldNumber,
    cartType,
  };
}
export function updateCartItemCompletion(
  cartType = 1,
  code,
  error = null,
  number = 0,
  data = {}
) {
  return {
    type: 'UPDATE_CART_ITEM_COMPLETION',
    cartType,
    code,
    error,
    number,
    data,
  };
}
export function loadCartMergeProductList(cartType = 1, query) {
  return {
    type: 'LOAD_CART_MERGE_PRODUCT_LIST',
    cartType,
    query,
    willReload: !!query,
  };
}

export function loadCartMergeProductListCompletion(
  cartType = 1,
  error = null,
  data = {}
) {
  return {
    type: 'LOAD_CART_MERGE_PRODUCT_LIST_COMPLETION',
    cartType,
    error,
    data,
  };
}

export function addCartMerge(addList = [], cartType = 1) {
  return {
    type: 'ADD_CART_MERGE',
    addList,
    cartType,
  };
}

export function addCartMergeCompletion(error = null, cartType = 1) {
  return {
    type: 'ADD_CART_MERGE_COMPLETION',
    error,
    cartType,
  };
}
export function loadCartActivityGiftList(activityId, money) {
  return {
    type: 'LOAD_CART_ACTIVITY_GIFT_LIST',
    activityId,
    money,
  };
}

export function loadCartActivityGiftListCompletion(activityId, error, list) {
  return {
    type: 'LOAD_CART_ACTIVITY_GIFT_LIST_COMPLETION',
    activityId,
    error,
    list,
  };
}
export function pickCartActivityGift(activityId, pickList, initialList) {
  return {
    type: 'PICK_CART_ACTIVITY_GIFT',
    activityId,
    pickList,
    initialList,
  };
}
export function pickCartActivityGiftCompletion(activityId, error) {
  return {
    type: 'PICK_CART_ACTIVITY_GIFT_COMPLETION',
    activityId,
    error,
  };
}

export function loadCartExtraInfo(
  cartType = 1,
  cashId,
  giftList = [],
  recoverData = {},
  from = ''
) {
  return {
    type: 'LOAD_CART_EXTRA_INFO',
    cartType,
    cashId,
    giftList,
    recoverData,
    from,
  };
}

export function loadCartExtraInfoCompletion(
  cartType = 1,
  error,
  data,
  orderType,
  selectedList,
  giftList,
  recoverData
) {
  return {
    type: 'LOAD_CART_EXTRA_INFO_COMPLETION',
    cartType,
    error,
    data,
    orderType,
    selectedList,
    giftList,
    recoverData,
  };
}

export function resetCartExtraInfo(cartType = 1) {
  return {
    type: 'RESET_CART_EXTRA_INFO',
    cartType,
  };
}

export function pickCartExtraInfoCash(cashId, cartType = 1) {
  return {
    type: 'PICK_CART_EXTRA_INFO_CASH',
    cashId,
    cartType,
  };
}

export function pickCartExtraInfoPostage(postageId, cartType = 1) {
  return {
    type: 'PICK_CART_EXTRA_INFO_POSTAGE',
    postageId,
    cartType,
  };
}

// 分享购物袋
export function resetCartShare() {
  return {
    type: 'RESET_CART_SHARE',
  };
}

export function loadCartShareInfo(list) {
  return {
    type: 'LOAD_CART_SHARE_INFO',
    list,
  };
}

export function loadCartShareInfoCompletion(data, error) {
  return {
    type: 'LOAD_CART_SHARE_INFO_COMPLETION',
    data,
    error,
  };
}

export function loadCartManJtLevels() {
  return {
    type: 'LOAD_CART_MAN_J_LEVELS',
  }
}

export function loadCartManJLevelsCompletion(error, list) {
  return {
    type: 'LOAD_CART_MAN_J_LEVELS_COMPLETION',
    error,
    list
  }
}
